import { useEffect, useState } from "react";
import { whatsappLink } from "../config";
import MatrumWord from "./MatrumWord";

const links = [
  { label: "Sobre mí", href: "#about" },
  { label: "Acompañamiento", href: "#services" },
  { label: "MATRUM", href: "#matrum" },
  { label: "Contacto", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-crema/90 backdrop-blur-md border-b border-rosa/30 py-3"
          : "bg-transparent py-5"
      }`}
    >
      <nav className="mx-auto max-w-7xl px-6 md:px-12 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex flex-col leading-none">
          <span className="font-serif text-3xl md:text-4xl tracking-tight leading-[0.95]">
            <span className="text-ciruela">Lorena</span>
            <br />
            <span className="italic text-terracota text-[2.1rem] md:text-[2.6rem]">Cotano</span>
          </span>
        </a>

        <div className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="font-sans text-sm tracking-wide text-ciruela-dark/80 hover:text-terracota transition-colors duration-300"
            >
              {l.label === "MATRUM" ? <MatrumWord className="text-xl leading-none" /> : l.label}
            </a>
          ))}
          <a
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-cta-whatsapp"
            className="font-sans text-sm font-medium rounded-full bg-terracota text-crema px-6 py-2.5 hover:bg-terracota-dark transition-colors duration-300"
          >
            Reserva tu sesión
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-ciruela p-2"
          aria-label="Menú"
        >
          <div className="space-y-1.5">
            <span className={`block h-0.5 w-6 bg-current transition-transform ${open ? "translate-y-2 rotate-45" : ""}`} />
            <span className={`block h-0.5 w-6 bg-current transition-opacity ${open ? "opacity-0" : ""}`} />
            <span className={`block h-0.5 w-6 bg-current transition-transform ${open ? "-translate-y-2 -rotate-45" : ""}`} />
          </div>
        </button>
      </nav>

      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden bg-crema border-t border-rosa/30 mt-3 px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="font-sans text-base text-ciruela-dark/85 hover:text-terracota"
            >
              {l.label === "MATRUM" ? <MatrumWord className="text-2xl leading-none" /> : l.label}
            </a>
          ))}
          <a
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setOpen(false)}
            className="font-sans text-center text-sm font-medium rounded-full bg-terracota text-crema px-6 py-3"
          >
            Reserva tu sesión
          </a>
        </div>
      )}
    </header>
  );
}
